import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { SITE_PROMISE } from '../lib/copy'

/**
 * The frame every route sits in. Header, a landmark `<main>` for the skip link, footer.
 * The workspace hides this chrome — the canvas needs the whole viewport (01 §3.5) — so
 * routes that want it render `<Shell.Bare>` content instead.
 */
export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh flex flex-col">
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-4">
          <Link
            to="/"
            className="font-mono text-xs font-semibold uppercase tracking-[0.1em] text-blue-deep min-[380px]:tracking-[0.18em]"
          >
            ASB Design Studio
          </Link>
          {/* The domain is a courtesy link back to the marketing site, not a control anyone
              needs. At 320 px it and the wordmark together forced the wordmark onto three
              lines, so below 380 px the wordmark keeps the row to itself. */}
          <a
            href="https://asbhomerenovations.com"
            className="hidden text-sm text-muted underline-offset-4 hover:underline min-[380px]:inline"
          >
            asbhomerenovations.com
          </a>
        </div>
      </header>

      <main id="main" className="flex-1">
        {children}
      </main>

      <footer className="border-t border-line bg-sand">
        <div className="mx-auto max-w-5xl px-5 py-6 text-sm text-muted">
          <p className="m-0">{SITE_PROMISE}</p>
          <p className="m-0 mt-2">
            ASB Home Renovations · Bathrooms, Tile &amp; Exteriors · Monmouth County, NJ
          </p>
          {/* 08 §2 asks for these to be published and reachable. A policy nobody can find from
              the page it governs is not published. */}
          <p className="m-0 mt-2 flex flex-wrap gap-x-4 gap-y-1">
            <Link to="/privacy" className="underline underline-offset-2 hover:text-ink">
              Privacy
            </Link>
            <Link to="/terms" className="underline underline-offset-2 hover:text-ink">
              Terms
            </Link>
            <a
              href="mailto:studio@asbhomerenovations.com"
              className="underline underline-offset-2 hover:text-ink"
            >
              studio@asbhomerenovations.com
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}
